function getFocusableElements(container) {
  return Array.from(container.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  const elements = getFocusableElements(container);
  const first = elements[0];
  const last = elements[elements.length - 1];
  
  removeTrapFocus();
  
  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;
    
    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };
  
  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };
  
  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }
    
    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };
  
  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);
  
  elementToFocus.focus();
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
          if (model.modelViewerUI){
             model.modelViewerUI.pause();
          }
        });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);
  
  if (elementToFocus) elementToFocus.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', {bubbles: true})
    this.querySelectorAll('button').forEach((button) => button.addEventListener('click', this.onButtonClick.bind(this)));
  }
  
  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

if (!customElements.get('quantity-input')) {
  customElements.define('quantity-input', QuantityInput);
}
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
  return {
    method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': `application/${type}`}
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function (selector, value) {
  let i = 0, count = selector.options.length;
  for (; i < count; i++) {
    const option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  const method = options['method'] || 'post';
  const params = options['parameters'] || {};
  
  const form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);
  
  for (const key in params) {
    const hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);
  
  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));
  
  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    const value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },
  
  initProvince: function () {
    const value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },
  
  countryHandler: function (e) {
    let opt = this.countryEl.options[this.countryEl.selectedIndex];
    const raw = opt.getAttribute('data-provinces');
    const provinces = JSON.parse(raw);
    
    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (let i = 0; i < provinces.length; i++) {
        opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }
      
      this.provinceContainer.style.display = "";
    }
  },
  
  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },
  
  setOptions: function (selector, values) {
    let count = values.length;
    for (let i = 0; i < count; i++) {
      const opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class DiscountComponent extends HTMLElement {
  constructor() {
    super();
    
    this.addEventListener('click', (e) => {
      const Input = document.createElement('input');
      Input.value = e.target.dataset.discount;
      document.body.appendChild(Input);
      Input.select();
      document.execCommand("Copy");
      Input.remove();
      UIkit.notification({message: 'Copied', pos: 'center', status: 'success'})
    });
  }
}

// customElements.define('discount-component', DiscountComponent)

// class TabFilter extends HTMLElement {
//   constructor() {
//     super();
//     this.updateSections();
//     this.querySelectorAll('[data-filter-tab]').forEach((element) => {
//       element.addEventListener('click', (event) => {
//         event.target.closest('ul').querySelectorAll('li').forEach(e => e.classList.remove('tm-active'))
//         event.target.closest('li').classList.add('tm-active');
//         this.updateSections(event.target.dataset.filterTab);
//       }, false);
//     })
//   }
  
//   /**
//    * update tabs state
//    * @param activeSection
//    */
//   updateSections(activeSection) {
//     const activeTab = activeSection ? activeSection : 'group_1';
//     document.querySelectorAll('[data-filter]').forEach(elem => elem.classList.add('uk-hidden'));
//     document.querySelectorAll(`[data-filter="${activeTab}"]`).forEach(elem => elem.classList.remove('uk-hidden'));
//   }
// }

// if(!customElements.get('tab-filter')){customElements.define('tab-filter', TabFilter);}

class backToTop extends HTMLElement {
  constructor() {
    super();
    document.addEventListener('scroll', () => {
      this.classList.toggle('uk-hidden', document.documentElement.scrollTop <= 600);
    });
  }
}
if(!customElements.get('back-to-top')){
customElements.define('back-to-top', backToTop);
  
}


// class SectionRedirect extends HTMLElement {
//   constructor() {
//     super();
//     this.time = this.dataset.time;
//     this.timer = null;
//     this.timeText = this.querySelector('[data-time]');
//     this.redirectUrl = this.querySelector('[href]').getAttribute('href');
//     this.init();
//   }
  
//   init() {
//     clearInterval(this.timer);
//     this.timeText.innerText = `${this.time}s`;
//     this.timer = setInterval(() => {
//       this.timeText.innerText = `${--this.time}s`;
//       if (this.time <= 0) {
//         clearInterval(this.timer);
//         this.redirect(this.redirectUrl);
//       }
//     }, 1000)
//   }
  
//   redirect(url = '/') {
//     if (!Shopify.designMode) {
//       window.location.href = url;
//     }
//   }
// }
// if(!customElements.get('section-redirect')){
// customElements.define('section-redirect', SectionRedirect);
// }



class CountdownTime extends HTMLElement {
  constructor() {
    super();
    let timer = null;
    const {time} = this.dataset;
    // Date.parse('2022-03-09T15:58:20+08:00'); 1646812700000
    const countdown = UIkit.countdown(this, {date: time});
    this.classList.toggle('uk-hidden', !countdown.timer);
    
    timer = setInterval(() => {
      if (Date.parse(time) - new Date().getTime() < 0) {
        this.remove();
        clearInterval(timer);
      }
    }, 100);
  }
}


if(!customElements.get('countdown-time')){
customElements.define('countdown-time', CountdownTime);
}

class videoComponent extends HTMLElement{
  constructor() {
    super();
    this.playsBtns = this.querySelectorAll('[data-code]');
    // 详情页面的视频点击
    this.detailBtn = this.querySelectorAll(".pointer-none");
    this.init();
  }
  
  play (code) {
    if(!code) return;
    const videoUrl = `//www.youtube-nocookie.com/embed/${code}?autoplay=0&amp;showinfo=0&amp;rel=0&amp;modestbranding=1&amp;playsinline=1`;
    const videoElement = `<button class="uk-modal-close-outside" type="button" uk-close></button><iframe src="${code}" width="1920" height="1080" allowfullscreen uk-responsive uk-video></iframe>`
    UIkit.modal.dialog(`<div>${videoElement}<style>.uk-modal{display: flex!important;}.uk-modal-dialog {width: 1200px;margin-top: auto!important;margin-bottom: auto!important;}</style></div>`);
  }
   playUrl (code) {
    if(!code) return;
    const videoElement = `<button class="uk-modal-close-outside" type="button" uk-close></button><iframe src="${code}" width="1920" height="1080" allowfullscreen uk-responsive uk-video></iframe>`
    UIkit.modal.dialog(`<div>${videoElement}<style>.uk-modal{display: flex!important;}.uk-modal-dialog {width: 1200px;margin-top: auto!important;margin-bottom: auto!important;}</style></div>`);
  } 
  init() {
    this.playsBtns.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.target.blur();
        this.play(e.target.dataset.code);
      });
    });
    
    this.detailBtn.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.target.blur();
        this.playUrl(e.target.dataset.code);
      });
    });
    
  }
}


if(!customElements.get('video-component')){
customElements.define('video-component', videoComponent);
}



class Slideshow {
  constructor(container) {
    this.container = container
    this.firstType = this.container.querySelector('[uk-slideshow].js-enable-top')
      ? this.container.querySelector('[uk-slideshow].js-enable-top li').classList.contains('uk-light')
      : false
    this.initSlideshow(this.firstType)
    this.init()
  }

  initSlideshow(flag) {
    const tmHeader = document.querySelector('.tm-header')
    if (tmHeader) {
      tmHeader.classList.toggle('uk-light', flag)
    }
  }

  init() {
    this.container.querySelector('[uk-slideshow].js-enable-top')?.addEventListener('beforeitemshow', (e) => {
      const is_light = e.target.classList.contains('uk-light')
      this.initSlideshow(is_light)
    })
  }
}
if (document.querySelector('[data-section-type="slideshow"]')) {
  new Slideshow(document.querySelector('[data-section-type="slideshow"]'))
}

// 订阅js开始
class valentineDayEmailBanner extends HTMLElement {
  constructor() {
    super()
    var toastSubmit = this.querySelector('.toast-form-submit')
    // var toastCheckboxElAll = this.querySelector('.form-checkbox');
    // var toastTermsPrivacyEl = this.querySelector('.terms-privacy');
    var toastErrorResponseEl = this.querySelector('.mce-error-response')
    var toastSuccessResponseEl = this.querySelector('.mce-success-response')
    // 请求的目标URL
    const toastApi = 'https://api.bluettipower.com/messageapi/subscribe/klaviyo' //正式环境
    //const toastApi = 'https://srv0.bluettipower.com/messageapi/subscribe/klaviyo'; //测试环境
    // this.toastTermsPrivacyEl = toastTermsPrivacyEl;
    this.toastErrorResponseEl = toastErrorResponseEl
    this.toastSuccessResponseEl = toastSuccessResponseEl
    this.toastApi = toastApi
    this.clearTime = 25000



    // 这里是新增的代码
    // 判断是否需要点击成功之后需要弹框展示内容
    this.isToast = this.dataset.term == 'true' ? true : false
    this.toast = {
      title:this.dataset.title,
      content:this.dataset.content,
      buttonText:this.dataset.btn,
      btnLink:this.dataset.url,
      info:this.dataset.info
    }; 

    toastSubmit.addEventListener('submit', this.submitForm.bind(this), false)
  }
  // 表单提交
  submitForm(event) {
    event.preventDefault()
    var emailValue = this.querySelector('[type="email"]').value
    var tags = event.target.querySelector('[name="tags"]').value
    var id = event.target.querySelector('[name="id"]').value
    var submitButton = this.querySelector('[type="submit"]')

    if (emailValue == '') return
    // var checkboxEl = this.querySelector('[type="checkbox"]');
    // var checkboxOff = checkboxEl.checked;

    // if (!checkboxOff) return;
    this.toastErrorResponseEl.classList.add('hidden')
    this.toastSuccessResponseEl.classList.add('hidden')

    // 请求参数
    let requestData = {
      email: emailValue,
      shop: Shopify.shop.split('.myshopify')[0],
      tag: tags,
      id: id
    }

    if(this.isToast){
      var temp = document.querySelector('#modal-banner-form');
      temp.querySelector('.banner-info-contain').innerHTML = `
        <h2>${this.toast.title}</h2>
        <p>${this.toast.content}</p>
        <div class="uk-flex uk-flex-center"><a href="${this.toast.btnLink}" class="uk-button uk-button-primary">${this.toast.buttonText}</a></div>
        <div class="footer-info">${this.toast.info}</div>
      `;
    }

    submitButton.disabled = true
    submitButton.classList.add('loading')
    this.toastPostData('post', this.toastApi, requestData).then((data) => {
        if(this.isToast){
          UIkit.modal('#modal-banner-form').show();
        }else{
            // 处理返回的数据
            if (data.code === 0 || data.code == 10001) {
              this.toastSuccessResponseEl.classList.remove('hidden')
              this.toastErrorResponseEl.classList.add('hidden')

              const dataToLink = this.getAttribute('data-to-link')
              if (dataToLink) {
                // js 跳转到锚点
                const anchor = document.querySelector(dataToLink)
                anchor.scrollIntoView({ behavior: 'smooth' })
              }
            } else {
              this.toastSuccessResponseEl.classList.add('hidden')
              this.toastErrorResponseEl.classList.remove('hidden')
            }
        }
        document.querySelector('.toast-form-submit').reset()
      })
      .catch((error) => {
        // 在这里处理错误，如果不需要额外处理，可以省略这一部分
        document.querySelector('.toast-form-submit').reset()
        console.error('Error in main:', error)
      })
      .finally(() => {
        // 这里的代码会在请求成功或失败后都执行
        document.querySelector('.toast-form-submit').reset()
        submitButton.disabled = false
        submitButton.classList.remove('loading')
      })
  }
  // 接口请求
  toastPostData(type, url, data) {
    if (type == 'post') {
      return fetch(url, {
        method: type,
        headers: {
          'Content-Type': 'application/json',
          shop: Shopify.shop.split('.myshopify')[0]
          // 如果有需要的话，可以添加其他请求头
        },
        body: JSON.stringify(data)
      })
        .then((response) => response.json())
        .catch((error) => {
          console.error('Error:', error)
          // 如果需要，你可以进一步处理错误
          throw error
        })
    } else {
      var param = url + '?shop=' + data.shop + '&page=' + data.page
      return fetch(param, {
        method: type,
        headers: {
          'Content-Type': 'application/json',
          shop: Shopify.shop.split('.myshopify')[0]
        }
      })
        .then((response) => response.json())
        .catch((error) => {
          console.error('Error:', error)
          // 如果需要，你可以进一步处理错误
          throw error
        })
    }
  }
}
if (!customElements.get('valentine-day-email-banner')) {
  customElements.define('valentine-day-email-banner', valentineDayEmailBanner)
}
// 订阅js结束





















